import React from 'react';
import {
  useActive,
  useChainedCommands,
  useCurrentSelection,
} from '@remirror/react';
import { EditorToolBarButton } from '../toolbar/EditorToolBarButton';
import { useToolbarActive } from '../toolbar/tools/utils';
import {
  BoldIcon,
  ItalicIcon,
  StrikethroughIcon,
  UnderlineIcon,
} from 'components/icons';

export function FormattingTools() {
  const selection = useCurrentSelection();
  const chain = useChainedCommands();
  const active = useActive();
  const { formattingDisabled } = useToolbarActive();

  return (
    <>
      <EditorToolBarButton
        onClick={() => chain.toggleBold().focus(selection).run()}
        selected={active.bold()}
        isDisabled={formattingDisabled}
        size="xs"
      >
        <BoldIcon />
      </EditorToolBarButton>
      <EditorToolBarButton
        onClick={() => chain.toggleItalic().focus(selection).run()}
        selected={active.italic()}
        isDisabled={formattingDisabled}
        size="xs"
      >
        <ItalicIcon />
      </EditorToolBarButton>
      <EditorToolBarButton
        onClick={() => chain.toggleUnderline().focus(selection).run()}
        selected={active.underline()}
        isDisabled={formattingDisabled}
        size="xs"
      >
        <UnderlineIcon />
      </EditorToolBarButton>
      <EditorToolBarButton
        onClick={() => chain.toggleStrike().focus(selection).run()}
        selected={active.strike()}
        isDisabled={formattingDisabled}
        size="xs"
      >
        <StrikethroughIcon />
      </EditorToolBarButton>
    </>
  );
}
